// This is in a separate module so we can easily mock this for Jest tests. Jest
// tests run in Node which doesn't support `import.meta.url` (in most cases).
export const importMetaURL = import.meta.url;
